export default (function (event) {
    var modifiers = [];
    if (event.ctrlKey) {
        modifiers.push('ctrlKey');
    }
    if (event.shiftKey) {
        modifiers.push('shiftKey');
    }
    if (event.altKey) {
        modifiers.push('altKey');
    }
    if (event.metaKey) {
        modifiers.push('metaKey');
    }
    return modifiers;
});



//////////////////
// WEBPACK FOOTER
// ./~/@reecelucas/react-use-hotkeys/esm/helpers/getActiveModifierKeys.js
// module id = 661
// module chunks = 0